export default "__VITE_ASSET__0VHhp$Ft__"